function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.2991 44.8872L43.7653 55.9494L39.4799 61.6904L25.0137 50.6281L29.2991 44.8872Z",
  fill: "#7D6EF1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M41.6124 39.0094L60.5985 39.0093L44.306 56.5812L29.8398 45.5189L41.6124 39.0094Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M79.0058 77.4386L79.4061 58.2266L61.7051 74.3424L72.3271 89.2144L79.0058 77.4386Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M93.6371 40.5466L95.5351 22.8662L75.0297 24.7881L35.1562 65.5295L52.2442 83.2101L93.6371 40.5466Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M62.4358 73.7812L73.0017 87.9089L67.3335 92.2514L56.7676 78.1241L62.4358 73.7812Z",
  fill: "#7D6EF1"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.1826 26.5641C77.4071 21.4181 85.8557 20.4257 94.9415 22.0354C95.3691 22.1111 95.7139 22.4308 95.8263 22.8551C98.3957 32.5513 94.583 41.3624 91.6544 45.6925C91.6142 45.7526 91.5678 45.8088 91.5162 45.8599L53.1537 84.039C52.7201 84.4711 52.025 84.4711 51.591 84.0398L33.9709 66.5375C33.7597 66.3277 33.6396 66.0415 33.6368 65.742C33.634 65.4424 33.7489 65.1541 33.9562 64.9403L71.0921 26.6476C71.1207 26.6181 71.151 26.5902 71.1826 26.5641ZM72.64 28.2749L36.3294 65.7165L52.3712 81.6514L89.8749 44.3271C92.5149 40.3792 95.8119 32.6264 93.8456 24.1393C85.4083 22.7716 78.0078 23.866 72.64 28.2749Z",
  fill: "#2A2827"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52.3543 40.2298C49.8389 40.2956 46.7934 40.3752 42.7724 40.7682C34.6187 41.565 28.6037 47.1324 26.0832 50.4855L38.9446 60.2352L37.5974 62.0706L23.0039 51.0079L23.5848 50.1067C25.8367 46.6135 32.7264 39.4495 42.5568 38.4888C46.6545 38.0884 49.8629 38.0038 52.4069 37.9367C53.5114 37.9075 54.4908 37.8817 55.3632 37.8347C58.2649 37.6786 60.0676 37.2953 61.952 35.9346L63.2571 37.8011C60.8606 39.5317 58.5514 39.9562 55.4824 40.1214C54.5206 40.1731 53.4916 40.2001 52.3543 40.2298Z",
  fill: "#2A2827"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M77.4841 65.0217C77.4036 67.5927 77.3064 70.6858 76.8947 74.7159C76.0639 82.8474 70.6202 88.8102 67.3493 91.3024L57.9817 78.3981L56.1914 79.7295L66.8207 94.3711L67.699 93.7984C71.104 91.5753 78.1031 84.7507 79.1049 74.9472C79.5249 70.8373 79.6266 67.5854 79.7087 64.9874C79.7436 63.8777 79.7747 62.8873 79.8256 62.0003C79.9958 59.0098 80.3816 57.1368 81.7099 55.2726L79.9084 53.957C78.2079 56.3432 77.7856 58.7365 77.6071 61.8709C77.5517 62.8424 77.5198 63.8807 77.4841 65.0217Z",
  fill: "#2A2827"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M80.7258 42.4686C80.7258 46.0772 77.8351 49.0026 74.2701 49.0026C70.7047 49.0026 67.8145 46.0772 67.8145 42.4686C67.8145 38.86 70.7047 35.9346 74.2701 35.9346C77.8351 35.9346 80.7258 38.86 80.7258 42.4686Z",
  fill: "#D5E9FA"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M66.2953 54.7676C66.2953 57.5271 64.085 59.7642 61.3586 59.7642C58.6321 59.7642 56.4219 57.5271 56.4219 54.7676C56.4219 52.008 58.6321 49.771 61.3586 49.771C64.085 49.771 66.2953 52.008 66.2953 54.7676Z",
  fill: "#D5E9FA"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M74.2701 46.7876C76.6268 46.7876 78.5377 44.854 78.5377 42.4686C78.5377 40.0832 76.6268 38.1494 74.2701 38.1494C71.9134 38.1494 70.0028 40.0832 70.0028 42.4686C70.0028 44.854 71.9134 46.7876 74.2701 46.7876ZM74.2701 49.0026C77.8351 49.0026 80.7258 46.0772 80.7258 42.4686C80.7258 38.86 77.8351 35.9346 74.2701 35.9346C70.7047 35.9346 67.8145 38.86 67.8145 42.4686C67.8145 46.0772 70.7047 49.0026 74.2701 49.0026Z",
  fill: "#2A2827"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.5196 58.1351C63.4605 58.1351 65.0338 56.5427 65.0338 54.5782C65.0338 52.6138 63.4605 51.0213 61.5196 51.0213C59.5787 51.0213 58.0053 52.6138 58.0053 54.5782C58.0053 56.5427 59.5787 58.1351 61.5196 58.1351ZM61.5196 59.9592C64.4558 59.9592 66.836 57.55 66.836 54.5782C66.836 51.6064 64.4558 49.1973 61.5196 49.1973C58.5834 49.1973 56.2031 51.6064 56.2031 54.5782C56.2031 57.55 58.5834 59.9592 61.5196 59.9592Z",
  fill: "#2A2827"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M39.3495 78.1943C41.7933 81.0054 43.2373 83.0287 38.5033 86.8245C35.0555 89.0369 33.0106 89.6795 31.0542 88.7878C30.7994 88.6717 30.7521 88.332 30.9328 88.116C36.698 81.226 32.5397 80.7418 30.0251 82.3845C29.7228 82.582 29.2914 82.4183 29.2969 82.0539C29.3278 80.0299 30.4458 77.8845 32.1985 76.7599C35.9288 74.366 36.6837 75.4963 39.3495 78.1943Z",
  fill: "#FFA263"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.1874 78.348C39.0407 78.1996 38.9003 78.0566 38.7654 77.919C38.2846 77.4286 37.8724 77.0081 37.4855 76.6643C36.9903 76.224 36.5566 75.9282 36.1054 75.7817C35.2204 75.4947 34.1774 75.7562 32.3174 76.9497C30.6309 78.032 29.5488 80.1052 29.5191 82.057C29.5179 82.1346 29.5577 82.1907 29.6318 82.2223C29.7114 82.2561 29.8172 82.2522 29.9046 82.1954C30.558 81.7687 31.3213 81.4774 32.0125 81.3951C32.6925 81.3136 33.3661 81.4297 33.7552 81.9071C34.1499 82.3914 34.1752 83.1501 33.7836 84.1648C33.3892 85.1864 32.5502 86.5309 31.1023 88.2612C30.9992 88.3842 31.0495 88.5387 31.1455 88.5825C32.9835 89.4204 34.9313 88.8493 38.3745 86.6408C40.7236 84.7551 41.4643 83.3661 41.3963 82.1531C41.3619 81.5396 41.1203 80.9416 40.7265 80.3159C40.3329 79.6894 39.797 79.0498 39.1874 78.348ZM38.5033 86.8245C43.2373 83.0286 41.7933 81.0054 39.3495 78.1942C39.2031 78.0459 39.0624 77.9029 38.9267 77.7645C36.5918 75.3827 35.7239 74.4975 32.1985 76.7599C30.4458 77.8844 29.3278 80.0299 29.2969 82.0539C29.2914 82.4183 29.7228 82.582 30.0251 82.3845C32.5397 80.7417 36.698 81.226 30.9328 88.1159C30.7521 88.3319 30.7994 88.6717 31.0542 88.7878C33.0106 89.6795 35.0555 89.0368 38.5033 86.8245Z",
  fill: "#FFA263"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M34.334 72.6162L39.0225 69.5508L47.4927 77.9564L44.297 82.6639L34.334 72.6162Z",
  fill: "#7D6EF1"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.8302 68.5049L48.6007 78.2011L44.1217 84.7997L32.2383 72.8146L38.8302 68.5049ZM35.7581 73.1902L43.8008 81.3013L45.7131 78.4848L38.5433 71.3692L35.7581 73.1902Z",
  fill: "#2A2827"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M47.395 9.94774C47.4873 9.20893 48.4597 9.02137 48.8141 9.674L49.5486 11.0268C49.7071 11.3186 50.0332 11.474 50.3564 11.4117L51.8546 11.1226C52.5774 10.9832 53.0541 11.8613 52.5504 12.4041L51.5062 13.5291C51.2809 13.7719 51.2356 14.1339 51.3941 14.4257L52.1286 15.7785C52.483 16.4312 51.8053 17.1614 51.1396 16.8443L49.7597 16.1868C49.462 16.045 49.1079 16.1132 48.8826 16.356L47.8384 17.4811C47.3347 18.0239 46.4391 17.5971 46.5314 16.8583L46.7228 15.3269C46.764 14.9965 46.5904 14.6768 46.2928 14.5349L44.9129 13.8775C44.2472 13.5604 44.3714 12.5663 45.0941 12.4269L46.5923 12.1379C46.9155 12.0755 47.1623 11.8096 47.2036 11.4792L47.395 9.94774Z",
  fill: "#FFF8E0"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M112.669 51.2693C113.146 50.7029 114.061 51.0861 114.003 51.8284L113.884 53.3674C113.858 53.6994 114.047 54.0104 114.351 54.1378L115.76 54.7281C116.44 55.0129 116.362 56.0117 115.648 56.1858L114.164 56.5465C113.844 56.6244 113.611 56.9019 113.585 57.2339L113.465 58.7728C113.408 59.5152 112.445 59.7494 112.06 59.1146L111.264 57.7986C111.091 57.5146 110.759 57.3751 110.438 57.453L108.956 57.8137C108.24 57.9878 107.723 57.1336 108.201 56.5672L109.19 55.3932C109.404 55.1399 109.433 54.7762 109.26 54.4922L108.463 53.1763C108.078 52.5415 108.722 51.7794 109.401 52.0642L110.81 52.6546C111.114 52.7819 111.465 52.6966 111.678 52.4433L112.669 51.2693Z",
  fill: "#FFF8E0"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M52.3792 100.597C52.9223 100.095 53.7832 100.589 53.6355 101.318L53.3293 102.831C53.2632 103.157 53.4122 103.489 53.6983 103.654L55.0247 104.416C55.6645 104.784 55.4657 105.765 54.7346 105.848L53.219 106.021C52.892 106.058 52.6259 106.304 52.5598 106.63L52.2536 108.142C52.1059 108.872 51.1221 108.984 50.818 108.306L50.1876 106.9C50.0515 106.597 49.7381 106.417 49.4111 106.454L47.8956 106.626C47.1644 106.71 46.7552 105.798 47.2984 105.295L48.4243 104.254C48.6672 104.03 48.7396 103.672 48.6036 103.369L47.9731 101.963C47.669 101.285 48.3998 100.61 49.0397 100.977L50.366 101.739C50.6521 101.903 51.0103 101.863 51.2532 101.638L52.3792 100.597Z",
  fill: "#FFF8E0"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M5.79194 60.9766C5.76112 60.2325 6.68896 59.8833 7.14597 60.4668L8.09333 61.6765C8.29771 61.9376 8.64487 62.0357 8.9533 61.9196L10.3827 61.3815C11.0724 61.1219 11.6873 61.9071 11.2802 62.5273L10.4361 63.8131C10.2541 64.0905 10.2692 64.455 10.4736 64.716L11.4209 65.9257C11.878 66.5093 11.3301 67.3438 10.6215 67.1436L9.15252 66.7285C8.83558 66.6389 8.49776 66.7661 8.31571 67.0435L7.4717 68.3292C7.06456 68.9495 6.11109 68.6801 6.08026 67.9361L6.01637 66.3938C6.00259 66.0611 5.77869 65.7751 5.46177 65.6856L3.99279 65.2705C3.28415 65.0703 3.24268 64.0692 3.93227 63.8096L5.36176 63.2715C5.67016 63.1555 5.86962 62.8516 5.85584 62.5188L5.79194 60.9766Z",
  fill: "#FFF8E0"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M106.879 4.45012C107.398 3.92154 108.281 4.37297 108.169 5.10891L107.937 6.63447C107.886 6.9636 108.051 7.28802 108.345 7.43807L109.706 8.13359C110.363 8.46906 110.212 9.45931 109.486 9.57861L107.981 9.82598C107.656 9.87933 107.402 10.1383 107.352 10.4674L107.119 11.993C107.006 12.7289 106.029 12.8894 105.693 12.2273L104.995 10.8546C104.845 10.5584 104.523 10.3941 104.198 10.4474L102.693 10.6948C101.966 10.8142 101.514 9.92314 102.032 9.39458L103.106 8.29886C103.338 8.06241 103.393 7.70189 103.242 7.40575L102.545 6.03305C102.208 5.37087 102.906 4.65966 103.563 4.99517L104.924 5.69066C105.218 5.84071 105.574 5.78225 105.805 5.54585L106.879 4.45012Z",
  fill: "#FFF8E0"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4858 33.6285C22.3247 33.6285 23.0048 32.9402 23.0048 32.0911C23.0048 31.242 22.3247 30.5537 21.4858 30.5537C20.6469 30.5537 19.9668 31.242 19.9668 32.0911C19.9668 32.9402 20.6469 33.6285 21.4858 33.6285Z",
  fill: "#FFF8E0"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M54.144 31.3224C54.9829 31.3224 55.663 30.6341 55.663 29.785C55.663 28.9359 54.9829 28.2476 54.144 28.2476C53.3051 28.2476 52.625 28.9359 52.625 29.785C52.625 30.6341 53.3051 31.3224 54.144 31.3224Z",
  fill: "#FFF8E0"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M79.9663 7.49231C80.8052 7.49231 81.4852 6.80399 81.4852 5.9549C81.4852 5.1058 80.8052 4.41748 79.9663 4.41748C79.1273 4.41748 78.4473 5.1058 78.4473 5.9549C78.4473 6.80399 79.1273 7.49231 79.9663 7.49231Z",
  fill: "#FFF8E0"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M96.6752 87.4381C97.5142 87.4381 98.1942 86.7498 98.1942 85.9007C98.1942 85.0516 97.5142 84.3633 96.6752 84.3633C95.8363 84.3633 95.1562 85.0516 95.1562 85.9007C95.1562 86.7498 95.8363 87.4381 96.6752 87.4381Z",
  fill: "#FFF8E0"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M114.144 32.0909C114.983 32.0909 115.663 31.4026 115.663 30.5535C115.663 29.7044 114.983 29.0161 114.144 29.0161C113.305 29.0161 112.625 29.7044 112.625 30.5535C112.625 31.4026 113.305 32.0909 114.144 32.0909Z",
  fill: "#FFF8E0"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M90.5991 61.3014C91.438 61.3014 92.118 60.6131 92.118 59.764C92.118 58.9149 91.438 58.2266 90.5991 58.2266C89.7602 58.2266 89.0801 58.9149 89.0801 59.764C89.0801 60.6131 89.7602 61.3014 90.5991 61.3014Z",
  fill: "#FFF8E0"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M35.1557 98.9684C35.9946 98.9684 36.6747 98.2801 36.6747 97.431C36.6747 96.5819 35.9946 95.8936 35.1557 95.8936C34.3168 95.8936 33.6367 96.5819 33.6367 97.431C33.6367 98.2801 34.3168 98.9684 35.1557 98.9684Z",
  fill: "#FFF8E0"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M4.01703 82.8258C4.85595 82.8258 5.53602 82.1375 5.53602 81.2884C5.53602 80.4393 4.85595 79.751 4.01703 79.751C3.17812 79.751 2.49805 80.4393 2.49805 81.2884C2.49805 82.1375 3.17812 82.8258 4.01703 82.8258Z",
  fill: "#FFF8E0"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4858 63.608C22.3247 63.608 23.0048 62.9197 23.0048 62.0706C23.0048 61.2215 22.3247 60.5332 21.4858 60.5332C20.6469 60.5332 19.9668 61.2215 19.9668 62.0706C19.9668 62.9197 20.6469 63.608 21.4858 63.608Z",
  fill: "#FFF8E0"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M82.2455 108.193C83.0844 108.193 83.7645 107.505 83.7645 106.656C83.7645 105.806 83.0844 105.118 82.2455 105.118C81.4066 105.118 80.7266 105.806 80.7266 106.656C80.7266 107.505 81.4066 108.193 82.2455 108.193Z",
  fill: "#FFF8E0"
});

var SvgRocketShip = function SvgRocketShip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 113,
    viewBox: "0 0 120 113",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRocketShip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/RocketShip.8da763a7.svg";
export { ForwardRef as ReactComponent };